/**
 * Area groupings for /jobs/categories.
 *
 * Suggested roles from the API usually include a `category` (DB field). Those
 * DB categories are mapped to the five public areas below. Roles missing a
 * category (or with an unmapped one) fall back to ROLE_AREA_OVERRIDES keyed by
 * role name; anything still unplaced is returned as `unplaced` so it can be
 * flagged in tests / logs.
 */

export const JOB_CATEGORY_AREAS = [
  {
    id: 'design',
    heading: 'Design',
    href: '/freelance/creatives',
  },
  {
    id: 'video-and-animation',
    heading: 'Video and animation',
    href: '/freelance/creatives',
  },
  {
    id: 'development',
    heading: 'Development',
    href: '/freelance/developers',
  },
  {
    id: 'marketing',
    heading: 'Marketing',
    href: '/freelance/marketing',
  },
  {
    id: 'music-and-audio',
    heading: 'Music and audio',
    href: '/freelance/creatives',
  },
];

/** Map SuggestedRoles.category (and Constants roleCategories values) → area id */
export const DB_CATEGORY_TO_AREA = {
  'Graphic Design': 'design',
  'Video & Animation': 'video-and-animation',
  'App & Web Development': 'development',
  'Digital Marketing': 'marketing',
  Music: 'music-and-audio',
  // Newer / adjacent categories collapse into the five public areas
  AI: 'development',
  'Business & Startups': 'marketing',
};

/**
 * Explicit name → area id for roles that have no (or an unmapped) API category.
 * Keep this list short; prefer fixing category data upstream when possible.
 */
export const ROLE_AREA_OVERRIDES = {
  Props: 'video-and-animation',
  'Visual Effects': 'video-and-animation',
  Keyboards: 'music-and-audio',
  Strings: 'music-and-audio',
  'French Horn Player': 'music-and-audio',
  'English Horn Player': 'music-and-audio',
  'Cymbal Player': 'music-and-audio',
  'Counter Tenor': 'music-and-audio',
  'Euphonium Player': 'music-and-audio',
  Piccolo: 'music-and-audio',
};
